import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CursorPaginatorComponent } from './cursor-paginator.component';
import {MaterialModule} from '../../material.module';
import {FormsModule} from '@angular/forms';


@NgModule({
  declarations: [CursorPaginatorComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule
    ],
  exports: [
    CursorPaginatorComponent
  ]
})
export class CursorPaginatorModule { }
